import { Stroke, Style } from "ol/style";
import { extractTags, getPropertyEndingWith } from "./propertyExtraction";
import { getDefaultColorStyle } from "./default";
import { getLinearTagFlowStyle } from "./linearStyling";
import { interpolatePuBuGn } from "d3-scale-chromatic";

export function getHDLaneWidthStyleNormal(feature, resolution) {
  return getHDLaneWidthColorStyle(feature, false, false, resolution);
}
export function getHDLaneWidthStyleClick(feature, resolution) {
  return getHDLaneWidthColorStyle(feature, true, false, resolution);
}
export function getHDLaneWidthStyleHover(feature, resolution) {
  return getHDLaneWidthColorStyle(feature, false, true, resolution);
}
function getHDLaneWidthColorStyle(feature, click, hover) {
  const tags = extractTags(feature);
  if (
    tags.hdMap !== "lane_center_line" &&
    tags.hdMap !== "lane_trajectory_line"
  ) {
    return [
      new Style({
        stroke: new Stroke({
          color: "transparent",
          width: 0,
        }),
      }),
    ];
  }
  let width, backgroundColor, backgroundWidth;
  let orbisLaneWidth = getPropertyEndingWith(feature, "width");
  if (orbisLaneWidth === undefined) {
    orbisLaneWidth = getPropertyEndingWith(feature, "width:linear");
  }

  if (orbisLaneWidth === undefined) {
    return getDefaultColorStyle(feature, click, hover);
  } else {
    if (click) {
      backgroundColor = "orange";
    } else {
      backgroundColor = "black";
    }
    if (hover || click) {
      width = 7;
      backgroundWidth = 10;
    } else {
      width = 5;
      backgroundWidth = 9;
    }
    const flowStyle = getLinearTagFlowStyle(
      orbisLaneWidth,
      width,
      feature,
      interpolatePuBuGn,
      "laneWidth",
    );
    return [
      flowStyle,
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
    ];
  }
}
